import React from 'react';

/**
 * The one "careful now" button look: a soft amber fill for actions that are neither the primary
 * step nor destructive - notifying the customer, unassigning a job. Keeping them identical stops
 * the screen collecting a different shade per action.
 */
export const cautionButtonStyle: React.CSSProperties = {
  backgroundColor: '#fffbe6',
  borderColor: '#fadb14',
  color: '#8c6d1f',
};
